// extracted by mini-css-extract-plugin
module.exports = {"jumb":"Home_jumb__16FVp"};